ï»¿if (!Number.isNaN) {
    (function(Number)
    {
        Number.isNaN = Number.isNaN || function isNaN(input) {
            return typeof input === 'number' && input !== input;
        }
    })(Number);
}